import gql from 'graphql-tag'

export default gql`
  query SendMail($to: String!, $receiver: String!, $actor: String!, $message: String!, $url: String!, $student: Boolean!, $company: Boolean!, $fromSwipe: Boolean, $matching: Boolean){
    sendMail (
      to: $to,
      receiver: $receiver,
      actor: $actor,
      message: $message,
      url: $url,
      student: $student,
      company: $company,
      fromSwipe: $fromSwipe,
      matching: $matching
    )
  }
`



// WEBPACK FOOTER //
// ./src/graphql/chat/queries/send-mail.query.js